import { Modal, Notification } from "@cea/ui-kit";
import PropTypes from "prop-types";
import { useMutation } from "@apollo/client";

import {
  DELETE_QA_FILE,
  DELETE_QA_FOLDER,
} from "../../../../queries/qaServices";
import { getNotification } from "../../../../utils";

const useFileFolderDeleteDialog = ({ onFileDelete, onFolderDelete }) => {
  const [deleteQAFile] = useMutation(DELETE_QA_FILE);
  const [deleteQAFolder] = useMutation(DELETE_QA_FOLDER);

  const deleteFolder = async (id) => {
    try {
      await deleteQAFolder({
        variables: {
          id,
        },
        notifyOnNetworkStatusChange: true,
      });

      onFolderDelete(id);
    } catch (error) {
      const message = getNotification(error);

      Notification.error({
        message,
      });
    }
  };

  const deleteFile = async (id) => {
    try {
      await deleteQAFile({
        variables: {
          id,
        },
        notifyOnNetworkStatusChange: true,
      });

      onFileDelete(id);
    } catch (error) {
      const message = getNotification(error);

      Notification.error({
        message,
      });
    }
  };

  const ShowDeleteDialog = (type, id, name) => {
    const isFile = type === "file";

    Modal.confirm({
      title: `Delete ${isFile ? "File" : "Folder"} :  ${name}`,
      okText: "Confirm",
      cancelText: "Cancel",
      onOk: () => {
        if (isFile) {
          deleteFile(id);
        } else {
          deleteFolder(id);
        }
      },
    });
  };

  return { ShowDeleteDialog };
};

useFileFolderDeleteDialog.defaultProps = {
  onFolderDelete: () => {},
  onFileDelete: () => {},
};

useFileFolderDeleteDialog.propTypes = {
  onFolderCreate: PropTypes.func.isRequired,
  onFileDelete: PropTypes.func.isRequired,
};

export default useFileFolderDeleteDialog;
